import { Injectable } from '@angular/core';
import { AppState } from './app_state';

@Injectable({ providedIn: 'root' })
export class AttendancePersistService {
  private LS_KEY = 'courseStartPageData';
  private LS_STUDENTS = 'Ogrenciler';
  private LS_YOKLAMA = 'YOKLAMA_STATE';

  // ================= SAVE =================
  saveAll(state: AppState, neresi?: string) {
    console.log('calıştı', neresi);

    const legacyState = this.mapStateToLegacy(state);

    const data = {
      ...legacyState,
    };


    localStorage.setItem(this.LS_KEY, JSON.stringify(data));

    localStorage.setItem(
      this.LS_STUDENTS,
      JSON.stringify(legacyState.students || []),
    );

    this.saveYoklama(legacyState);
  }


  mapStateToLegacy(state: AppState) {
    return {
      // COURSE
      courseId: state.course.courseId,
      courseStartId: state.course.courseStartId,
      dersBaslangic: state.course.dersBaslangic,
      dersBitis: state.course.dersBitis,

      // ATTENDANCE
      slotCount: state.attendance.slotCount,
      totalSessionHours: state.attendance.totalSessionHours,
      attendanceDuration: state.attendance.attendanceDuration,

      // ⚠️ eski isim
      _yoklamaPeriyodu: state.attendance.yoklamaPeriyodu,

      // UI
      qrUret: state.ui.qrUret,
      konumKontrol: state.ui.konumKontrol,

      // META
      teacherId: state.course.teacherId,
      token: state.ui.qrToken,

      // QR
      qrBase64: state.ui.qrBase64,

      // IDS
      acilanDersDetayNo: state.course.acilanDersDetayNo,
      akademikPersonelNo: state.course.akademikPersonelNo,
      acilanDersNo: state.course.acilanDersNo,
      gun: state.course.gun,
      aktifSlotIndex: state.attendance.aktifSlotIndex, // 🔥 EKLE
      yoklamaPeriyodu: state.attendance.yoklamaPeriyodu, // 🔥 DÜZELT
      dersbasldimi: state.attendance.dersbasldimi, // 🔥 EKLE
      // STUDENTS (önemli)
      students: state.attendance.students,
      latitude: state.ui.latitude,
      longitude: state.ui.longitude,
      kampusLatitude: state.ui.kampusLatitude,
      kampusLongitude: state.ui.kampusLongitude,
      binaLatitude: state.ui.binaLatitude,
      binaLongitude: state.ui.binaLongitude,
      dersAd: state.course.dersAd,
      dersAdres: state.course.dersAdres,
    };
  }
  // ================= LOAD =================
  load(): any {
    const raw = localStorage.getItem(this.LS_KEY);


    return raw ? JSON.parse(raw) : null;
  }

  loadStudents(): any[] {
    const raw = localStorage.getItem(this.LS_STUDENTS);
    return raw ? JSON.parse(raw) : [];
  }

  loadYoklama(): any {
    const raw = localStorage.getItem(this.LS_YOKLAMA);
    return raw ? JSON.parse(raw) : null;
  }

  // ================= YOKLAMA =================
  saveYoklama(state: any) {
    const data = {
      yoklamaBasladimi: state.yoklamaBasladimi,
      qrgorunumu: state.qrgorunumu,
      createdDate: state.createdDate,
      attendanceDuration: state.attendanceDuration,
    };

    localStorage.setItem(this.LS_YOKLAMA, JSON.stringify(data));
  }

  clearAll() {
    localStorage.removeItem(this.LS_KEY);
    localStorage.removeItem(this.LS_STUDENTS);
    localStorage.removeItem(this.LS_YOKLAMA);
  }
}
